import { translate as t } from '@thoughtspot/i18n';
import { Select } from '@thoughtspot/radiant-react/widgets/select';
import React, { useCallback } from 'react';
export const LiveboardSelector = ({ onSelect, selectedOptionIds, disabled = false, options, loading, onSearchInput, }) => {
    const handleSearchInput = useCallback((input) => {
        onSearchInput(input);
    }, [onSearchInput]);
    const handleChange = useCallback((option) => {
        const selected = Array.isArray(option) ? option : [option];
        onSelect(selected
            .filter((o) => !!o)
            .map(o => ({ id: o.id, name: o.label })));
    }, [onSelect]);
    const optionsGroups = [
        {
            options: options.map(liveboard => ({
                id: liveboard.id,
                label: liveboard.name || liveboard.id,
            })),
        },
    ];
    return (React.createElement(Select.Dropdown, { id: "translation-liveboard-selector", "data-testid": "translation-liveboard-selector", isSearchEnabled: true, multiSelect: true, onSearchInput: handleSearchInput, selectedOptions: selectedOptionIds, optionsGroups: optionsGroups, dropdownWidth: "minTargetWidth", loading: loading, placeholder: t('adminSection.manualTranslation.selectLiveboard'), onChange: handleChange, disabled: disabled }));
};
//# sourceMappingURL=liveboard-selector.js.map